module.exports = __webpack_public_path__ + "img/5.dfa373f2.jpg";